import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AnimatePresence } from "framer-motion";
import { SectionLayout } from "@/layouts";
import { AutoSlider, FunctioningCard } from "./functioningComponents";
import {
  CardSteps,
  MainScreenContainer,
  StepsTitle,
} from "./howItWorks.styles";
import * as Styled from "../home.styles";

interface Props {
  selecteditem: number;
}

const HowItWorks: FC<Props> = ({ selecteditem }) => {
  const { t } = useTranslation("global");

  const cardTitles = ["setup", "operate", "support"];

  return (
    <SectionLayout id="functioning">
      <AnimatePresence>
        <MainScreenContainer>
          <AutoSlider selecteditem={selecteditem} />
          <StepsTitle>
            <Styled.SectionTitle
              className="display-large weight-medium"
              color={
                selecteditem === 6
                  ? "var(--on-surface-light)"
                  : "var(--on-surface-dark)"
              }
            >
              {t("functioning.title")}
            </Styled.SectionTitle>
          </StepsTitle>
          <CardSteps>
            {cardTitles.map((title, index) => (
              <FunctioningCard
                key={index}
                title={title}
                idx={index}
                selecteditem={selecteditem}
              />
            ))}
          </CardSteps>
        </MainScreenContainer>
      </AnimatePresence>
    </SectionLayout>
  );
};

export default HowItWorks;
